export enum ActionType {
  GET_REPORTS = 'GET_REPORTS',
  GET_REPORTS_REJECTED = 'GET_REPORTS_REJECTED',
  GET_REPORTS_FULFILLED = 'GET_REPORTS_FULFILLED',
  GET_MORE_REPORTS = 'GET_MORE_REPORTS',
  GET_MORE_REPORTS_REJECTED = 'GET_MORE_REPORTS_REJECTED',
  GET_MORE_REPORTS_FULFILLED = 'GET_MORE_REPORTS_FULFILLED',
  GET_REPORT_FILTER_OPTIONS = 'GET_REPORT_FILTER_OPTIONS',
  GET_REPORT_FILTER_OPTIONS_REJECTED = 'GET_REPORT_FILTER_OPTIONS_REJECTED',
  GET_REPORT_FILTER_OPTIONS_FULFILLED = 'GET_REPORT_FILTER_OPTIONS_FULFILLED',
}
export default ActionType;
